import { atom } from 'recoil'

export type ReDirectionAtomType = {
  loadId: string
  pathname: string
  tripLegId: string
  type: string
}

const DEFAULT_STATE = {
  loadId: '',
  pathname: '',
  tripLegId: '',
  type: '',
}

export const reDirectionAtom = atom<ReDirectionAtomType>({
  key: 'reDirectionAtomType',
  default: DEFAULT_STATE,
})
